import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function Counter(props) {
  const { t } = useTranslation();
  const [count, setCount] = useState(props.qty);
  const handleIncrease = () => debouncedOnChange(parseFloat(count) + 1);
  const handleDecrease = () => debouncedOnChange(count - 1);
  const debouncedOnChange = (val) => {
    if (val < 0) {
      val = 0;
    }
    setCount(val);
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    let qty = value.replace(/^0+/, "");
    if (qty <= 0) {
      qty = 0;
    }
    if (!isNaN(qty)) {
      setCount(parseInt(qty));
    }
  };
  const handleOnChange = (e) => {
    const value = e.target.value;
    let qty = value.replace(/^0+/, "");
    if (qty <= 0) {
      qty = 0;
    }
    setCount(qty);
  };
  const updateCart = () => {
    props.updateCart(count);
    if (props.onUpdateQuantity) {
    props.onUpdateQuantity(count); // Call parent's handler to update total price
  }
  };
  return (
    <div className="cartincrease">
      <button
        className="handleDecrease"
        onClick={handleDecrease}
        disabled={count <= 0}
      ></button>
      <div className="counts">
        <input
          type="text"
          className="cart-qty"
          maxLength={5}
          value={count}
          onChange={handleInputChange}
          onBlur={handleOnChange}
        />
      </div>
      <button className="handleIncrease" onClick={handleIncrease}></button>
      <span className="kg">{props.unit}</span>
      <button className="atc" onClick={updateCart}>
        {" "}
        {t("update")}{" "}
      </button>
    </div>
  );
}

export default Counter;
